import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PRODUCT', [
    'STEP1',
    'CONDIFICATION',
    'STEP2',
    'TABLE_PRODUCTS',
    'COMPANIES',
    'FISCAL_CODE',
    'TAXES',
    'PERMITS'
])

export const PRODUCT_TYPES = ['Equipos', 'Consumibles', 'Servicios'] as const

// Categorías y subcategorías por tipo de producto
export interface CategoryData {
    name: string
    subcategories: string[]
}

export const PRODUCT_CATEGORIES: Record<string, CategoryData[]> = {
    '0': [
        // Equipos
        {
            name: 'Equipos de Laboratorio',
            subcategories: [
                'Espectrofotómetros',
                'Colorímetros',
                'Electroquímica',
                'Turbidímetros',
                'Microscopios',
                'Balanzas',
                'DBO y DQO',
                'Microbiología',
                'Repuestos, partes y accesorios para Laboratorios'
            ]
        },
        {
            name: 'Instrumentación y Medición en Línea',
            subcategories: [
                'Cloro',
                'Colorimetría',
                'Electroquímica',
                'Turbidez',
                'Caudal',
                'Controladores',
                'Transmisores y Dataloggers',
                'Meteorología',
                'Repuestos, partes y accesorios de Instrumentación'
            ]
        },
        {
            name: 'Manejo de Fluidos',
            subcategories: [
                'Bombas Dosificadoras de Solenoide',
                'Bombas Dosificadoras Peristálticas',
                'Bombas Dosificadoras con Motor',
                'Bombas Neumáticas',
                'Bombas Sumergibles',
                'Bombas Achique',
                'Bombas Centrífugas',
                'Bombas Booster',
                'Cloradores',
                'Balanzas de Cloración',
                'Filtros y Purificadores',
                'Membranas de Filtración',
                'Equipos para Limpieza Industrial',
                'Repuestos, partes y accesorios para Manejo de Fluidos'
            ]
        },
        {
            name: 'Otros Productos',
            subcategories: ['Otros Equipos']
        }
    ],
    '1': [
        // Consumibles
        {
            name: 'Microbiología',
            subcategories: ['Alimentos', 'Superficies', 'Aguas']
        },
        {
            name: 'Reactivos de Laboratorio',
            subcategories: [
                'Estándar',
                'Peligrosos',
                'Controlados (Minsa Precursores, ICD, Conapred)',
                'Refrigerados',
                'Especiales Peligrosos (No Hach)'
            ]
        },
        {
            name: 'Productos Químicos',
            subcategories: [
                'Tratamiento de Aguas',
                'Limpieza',
                'Industriales',
                'Resinas de Intercambio Iónico'
            ]
        },
        {
            name: 'Manejo de Fluidos',
            subcategories: ['Membranas de Filtración']
        },
        {
            name: 'Otros Productos',
            subcategories: ['Otros Consumibles']
        }
    ],
    '2': [
        // Servicios
        {
            name: 'Servicios',
            subcategories: [
                'Reparación',
                'Mantenimiento',
                'Calibración',
                'Instalación',
                'Capacitación',
                'Alquiler/Comodato',
                'Garantía Extendida',
                'Logísticos',
                'Financieros',
                'Licencias'
            ]
        },
        {
            name: 'Otros Productos',
            subcategories: ['Otros Servicios']
        }
    ]
}
